import translations from '../../components/location/ts/es-US';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('es-US', translations);
